export default __webpack_public_path__ + "static/media/jesseClick.23bc3420.png";